
/* eslint-disable */
import * as login from './login'
import * as query from './query'
import * as qftx from './qftx'
import * as message from './message'
export default {
  ...login,
	...query,
	...qftx,
	...message,
}
